import React from "react";
import { Accordion } from "react-bootstrap";
import buy_image from "../../assets/image/png/drone1.png";
import image1 from "../../assets/image/png/image1.png";
import image2 from "../../assets/image/png/image2.png";
import image3 from "../../assets/image/png/image3.png";

const EnlistNewDroneHero = () => {
  return (
    <div className="py-5 background_light">
      <div className="container">
        <h4 className=" fs_37 ff_inter fw-bold color_darkgray mb-0">
          Enlist New Drone
        </h4>
        <div className="row">
          <div className="col-xl-8 col-lg-7 new_drone_accordion">
            <Accordion className="mt-3 " defaultActiveKey="0">
              <Accordion.Item className="" eventKey="0">
                <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
                  <div className="counting_bg d-flex justify-content-center align-items-center text-white fs_21 fw-semibold ff_inter me-3">
                    1
                  </div>
                  <p className=" fs_17 ff_inter fw-medium color_darkgray mb-0">
                    Manufacturer Details
                  </p>
                </Accordion.Header>
                <Accordion.Body className="fs_17 ff_inter color_darkgray">
                  <div className="row align-items-center">
                    <div className="col-sm-4 mt-4">
                      <h6 className="mb-0 fs_14 fw-medium ff_inter color_darkgray">
                        Manufacturer Name
                      </h6>
                    </div>
                    <div className="col-sm-8 mt-sm-4 mt-2">
                      <input
                        className=" custom_input custom_input w-100 rounded-2 py-2 px-3"
                        type="text"
                      />
                    </div>
                    <div className="col-sm-4 mt-4">
                      <h6 className="mb-0 fs_14 fw-medium ff_inter color_darkgray">
                        Manufacturer Address 
                      </h6>
                    </div>
                    <div className="col-sm-8 mt-sm-4 mt-2">
                      <input
                        className=" custom_input custom_input w-100 rounded-2 py-2 px-3"
                        type="text"
                      />
                    </div>
                    <div className="col-sm-4 mt-4">
                      <h6 className="mb-0 fs_14 fw-medium ff_inter color_darkgray">
                        Email
                      </h6>
                    </div>
                    <div className="col-sm-8 mt-sm-4 mt-2">
                      <input
                        className=" custom_input custom_input w-100 rounded-2 py-2 px-3"
                        type="text"
                      />
                    </div>
                    <div className="col-sm-4 mt-4">
                      <h6 className="mb-0 fs_14 fw-medium ff_inter color_darkgray">
                        Contact Number
                      </h6>
                    </div>
                    <div className="col-sm-8 mt-sm-4 mt-2">
                      <input
                        className=" custom_input custom_input w-100 rounded-2 py-2 px-3"
                        type="text"
                      />
                    </div>
                    <div className="col-sm-4 mt-4">
                      <h6 className="mb-0 fs_14 fw-medium ff_inter color_darkgray">
                        RPA Model No/Name
                      </h6>
                    </div>
                    <div className="col-sm-8 mt-sm-4 mt-2">
                      <input
                        className=" custom_input custom_input w-100 rounded-2 py-2 px-3"
                        type="text"
                      />
                    </div>
                    <div className="col-sm-4 mt-4">
                      <h6 className="mb-0 fs_14 fw-medium ff_inter color_darkgray">
                        Description
                      </h6>
                    </div>
                    <div className="col-sm-8 mt-sm-4 mt-2">
                      <input
                        className=" custom_input custom_input w-100 rounded-2 py-2 px-3"
                        type="text"
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item className=" mt-3" eventKey="1">
                <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
                  <div className="counting_bg d-flex justify-content-center align-items-center text-white fs_21 fw-semibold ff_inter me-3">
                    2
                  </div>
                  <p className=" fs_17 ff_inter fw-medium color_darkgray mb-0">
                    RPA Details
                  </p>
                </Accordion.Header>
                <Accordion.Body className="fs_17 ff_inter color_darkgray">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item className=" mt-3" eventKey="2">
                <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
                  <div className="counting_bg d-flex justify-content-center align-items-center text-white fs_21 fw-semibold ff_inter me-3">
                    3
                  </div>
                  <p className=" fs_17 ff_inter fw-medium color_darkgray mb-0">
                    Compatible Payloads
                  </p>
                </Accordion.Header>
                <Accordion.Body className="fs_17 ff_inter color_darkgray">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item className=" mt-3" eventKey="3">
                <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
                  <div className="counting_bg d-flex justify-content-center align-items-center text-white fs_21 fw-semibold ff_inter me-3">
                    4
                  </div>
                  <p className=" fs_17 ff_inter fw-medium color_darkgray mb-0">
                    Weight
                  </p>
                </Accordion.Header>
                <Accordion.Body className="fs_17 ff_inter color_darkgray">
                  <div className="row align-items-center">
                    <div className="col-sm-6 mt-4">
                      <h6 className="mb-0 fs_14 fw-medium ff_inter color_darkgray">
                        Empty Weight (w/o battery and payload):
                      </h6>
                    </div>
                    <div className="col-sm-6 d-flex align-items-center gap-2 mt-sm-4 mt-2">
                      <input
                        className=" custom_input custom_input w-100 rounded-2 py-2 px-3"
                        type="text"
                      />
                      <span>g</span>
                    </div>
                    <div className="col-sm-6 mt-4">
                      <h6 className="mb-0 fs_14 fw-medium ff_inter color_darkgray">
                        Maximum Takeoff Weight (MTOW)
                      </h6>
                    </div>
                    <div className="col-sm-6 d-flex align-items-center gap-2 mt-sm-4 mt-2">
                      <input
                        className=" custom_input custom_input w-100 rounded-2 py-2 px-3"
                        type="text"
                      />
                      <span>g</span>
                    </div>
                    <div className="col-sm-6 mt-4">
                      <h6 className="mb-0 fs_14 fw-medium ff_inter color_darkgray">
                        Maximum Payload Capacity
                      </h6>
                    </div>
                    <div className="col-sm-6 d-flex align-items-center gap-2 mt-sm-4 mt-2">
                      <input
                        className=" custom_input custom_input w-100 rounded-2 py-2 px-3"
                        type="text"
                      />
                      <span>g</span>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item className=" mt-3" eventKey="4">
                <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
                  <div className="counting_bg d-flex justify-content-center align-items-center text-white fs_21 fw-semibold ff_inter me-3">
                    5
                  </div>
                  <p className=" fs_17 ff_inter fw-medium color_darkgray mb-0">
                    Power Platform Details
                  </p>
                </Accordion.Header>
                <Accordion.Body className="fs_17 ff_inter color_darkgray">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item className=" mt-3" eventKey="5">
                <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
                  <div className="counting_bg d-flex justify-content-center align-items-center text-white fs_21 fw-semibold ff_inter me-3">
                    6
                  </div>
                  <p className=" fs_17 ff_inter fw-medium color_darkgray mb-0">
                    Safety & Security Features
                  </p>
                </Accordion.Header>
                <Accordion.Body className="fs_17 ff_inter color_darkgray">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
          <div className="col-xl-4 col-lg-5 ps-md-5 custom_top  position-sticky h-100 overflow-y-auto">
            <div className="  detail_box rounded-4 pe-lg-0  mt-4 mt-lg-3">
              <div className=" ">
                <div className="tab_btn rounded-4 p-md-4 p-3">
                  <h4 className=" fs_26 ff_inter fw-bold text-white text-center">
                    What can we help you
                    <br className="d-xl-block d-none "></br> today with?
                  </h4>

                  <div className="row ">
                    <div className="col-6 mt-4">
                      <div className="card h-100 text-center p-3">
                        <div className="mx-auto">
                          <img width={80} src={buy_image} alt="buy_image" />
                        </div>
                        <h3 className=" fw-bold fs_12 ff_inter color_darkgray mb-0 mt-3">
                          Buy Drone
                        </h3>
                      </div>
                    </div>
                    <div className="col-6 mt-4">
                      <div className="card h-100 text-center p-3">
                        <div className="mx-auto">
                          <img width={80} src={image1} alt="image1" />
                        </div>
                        <h3 className=" fw-bold fs_12 ff_inter color_darkgray mb-0 mt-3">
                          Drone Spares Parts
                        </h3>
                      </div>
                    </div>
                    <div className="col-6 mt-4">
                      <div className="card h-100 text-center p-3">
                        <div className="mx-auto">
                          <img width={80} src={image2} alt="image2" />
                        </div>
                        <h3 className=" fw-bold fs_12 ff_inter color_darkgray mb-0 mt-3">
                          Find Pilot Jobs
                        </h3>
                      </div>
                    </div>
                    <div className="col-6 mt-4">
                      <div className="card h-100 text-center p-3">
                        <div className="mx-auto">
                          <img width={80} src={image3} alt="image3" />
                        </div>
                        <h3 className=" fw-bold fs_12 ff_inter color_darkgray mb-0 mt-3">
                          Get Training
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnlistNewDroneHero;
